
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1189:1749)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#E52E40"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27 18a5 5 0 1010 0 5 5 0 00-10 0zm7.828 2.828a4 4 0 11-5.656-5.656 4 4 0 015.656 5.656zm-4.567-.383l4.185-4.183a3.019 3.019 0 00-.707-.707l-4.184 4.183c.194.274.433.513.707.707zM15 31.477V33h12v-1.524a3.84 3.84 0 00-1.098-2.694 3.72 3.72 0 00-2.652-1.115h-4.5a3.72 3.72 0 00-2.652 1.115A3.84 3.84 0 0015 31.476zm4.278-5.681a4.44 4.44 0 004.904-.991A4.609 4.609 0 0025.5 21.57a4.609 4.609 0 00-1.318-3.232A4.465 4.465 0 0021 17c-.59 0-1.176.118-1.722.348a4.496 4.496 0 00-1.46.99 4.58 4.58 0 00-.976 1.484 4.635 4.635 0 000 3.499c.227.554.558 1.058.976 1.483.418.424.914.761 1.46.99z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1189:1749","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1189:1749"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1189:1749","result":"shape"}})])])])
          )
        }
      }
    